import type { TrackEventResponse } from "@/services/loyalty/types";
import type { ToastNotificationManager } from "@/ui/toast-notification-manager";
import type { SDKState } from "@/state/sdk-state";
import type { AuthService } from "@/services/auth/auth";
import { IntegrationMode } from "@/state/sdk-channel-info-state";
import { buildHostEmbeddedAppUrl } from "@f3/shared/embed-url";

export function showLoyaltyToastNotification(
  manager: ToastNotificationManager,
  props: TrackEventResponse,
  state: SDKState,
  authService: AuthService,
) {
  if (!props.notificationMessage) {
    return;
  }

  function navigateToScore() {
    const channelId = state.channelInfo.channelId;
    const url = channelId
      ? buildHostEmbeddedAppUrl(window.location.href, `/${channelId}`, {
          channelId,
        })
      : state.options.appOrigin;
    window.open(url);
  }

  function triggerAuthentication() {
    console.log(
      "Triggering authentication flow for loyalty toast notification",
    );
    if (state.channelInfo.integrationMode === IntegrationMode.FanfestAuth) {
      authService.openAuthModal();
    } else {
      if (!state.options.hostLoginFn) {
        console.warn(
          "[FanfestSDK] hostLoginFn is not set for SSO integration mode",
        );
        return;
      }
      state.options.hostLoginFn();
    }
  }

  const actionLabel = state.authState.isAuthenticated
    ? "View Score"
    : "Claim Rewards";
  const actionCallback = state.authState.isAuthenticated
    ? navigateToScore
    : triggerAuthentication;

  return manager.show({
    message: props.notificationMessage,
    actionCallback,
    actionLabel,
    points: props.points,
    duration: 5000,
  });
}
